export default {
	meta: {
		title: 'Facturation',
		description: 'Facturation'
	}
};
